import { gql } from '@apollo/client'

const TANK_FUEL_LEVELS_AND_DELIVERIES_QUERY = gql`
  query tankFuelLevelsAndDeliveries(
    $stationId: ID!
    $fuelGradeId: Int!
    $currentPeriodStartDate: String
    $currentPeriodEndDate: String
  ) {
    tankFuelLevelsAndDeliveries(
      input: {
        stationId: $stationId
        fuelGradeId: $fuelGradeId
        currentPeriodStartDate: $currentPeriodStartDate
        currentPeriodEndDate: $currentPeriodEndDate
      }
    ) {
      dates
      tanks {
        tankName
        tankFuelLevel
        deliveredFuelVolume
        fuelValueInStock
        fuelVolumeSold
      }
    }
  }
`

const TANK_FUEL_LEVELS_AND_DELIVERIES_BY_FUEL_GRADE_QUERY = gql`
  query tankFuelLevelsAndDeliveriesByFuelGrade(
    $stationId: ID!
    $fuelGradeIds: [Int!]!
    $currentPeriodStartDate: String
    $currentPeriodEndDate: String
  ) {
    tankFuelLevelsAndDeliveriesByFuelGrade(
      input: {
        stationId: $stationId
        fuelGradeIds: $fuelGradeIds
        currentPeriodStartDate: $currentPeriodStartDate
        currentPeriodEndDate: $currentPeriodEndDate
      }
    ) {
      dates
      grades {
        fuelGradeId
        tanks {
          tankName
          tankFuelLevel
          deliveredFuelVolume
          fuelValueInStock
          fuelVolumeSold
        }
      }
    }
  }
`

export {
  TANK_FUEL_LEVELS_AND_DELIVERIES_QUERY,
  TANK_FUEL_LEVELS_AND_DELIVERIES_BY_FUEL_GRADE_QUERY,
}
